import { render, staticRenderFns } from "./DictAuto.vue?vue&type=template&id=2351f8f9&"
import script from "./DictAuto.vue?vue&type=script&lang=js&"
export * from "./DictAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports